export default {
    SUPER_ADMIN: 'super_admin',
    GROUP_ADMIN: 'group_admin',
    COMPANY_USER: 'company_user',
};
